import { Form, Modal, Stack, TextInput } from '@carbon/react';
import { create, eager, enforce, test } from 'vest';

import OverlayLoader from 'shared/components/OverlayLoader';
import useForm from 'utils/hooks/useForm';
import useUpdateEffect from 'utils/hooks/useUpdateEffect';

const mapDefaultValues = (subGroup) => ({
  name: subGroup?.name ?? '',
  attendanceRate: subGroup?.attendanceRate.toString() ?? '',
  acceptableAttendanceRateDeviation: subGroup?.acceptableAttendanceRateDeviation.toString() ?? ''
});

const suite = create((data = {}) => {
  eager();

  test('name', 'Name is required', () => {
    enforce(data.name).isNotEmpty();
  });

  test('attendanceRate', 'Attendance Rate is required', () => {
    enforce(data.attendanceRate).isNotEmpty();
  });

  test('attendanceRate', 'Attendance Rate must be a number', () => {
    enforce(data.attendanceRate).isNumeric();
  });

  test('acceptableAttendanceRateDeviation', 'Acceptable Attendance Rate Deviation is required', () => {
    enforce(data.acceptableAttendanceRateDeviation).isNotEmpty();
  });

  test('acceptableAttendanceRateDeviation', 'Acceptable Attendance Rate Deviation must be a number', () => {
    enforce(data.acceptableAttendanceRateDeviation).isNumeric();
  });
});

const SubGroupModal = ({ open, subGroup, onClose, onSubmit, isLoading }) => {
  const { register, handleSubmit, reset } = useForm({
    suite,
    defaultValues: mapDefaultValues(subGroup)
  });

  useUpdateEffect(() => {
    if (open) {
      reset(mapDefaultValues(subGroup));
    }
  }, [open, subGroup]);

  const handleFormSubmit = (values) =>
    onSubmit({
      name: values.name,
      attendanceRate: Number(values.attendanceRate),
      acceptableAttendanceRateDeviation: Number(values.acceptableAttendanceRateDeviation)
    });

  return (
    <Modal
      open={open}
      modalHeading="Edit Sub Group"
      primaryButtonText="Save"
      secondaryButtonText="Reset"
      onRequestClose={onClose}
      onRequestSubmit={handleSubmit(handleFormSubmit)}
      onSecondarySubmit={() => reset()}
      preventCloseOnClickOutside
    >
      <Form onSubmit={handleSubmit(handleFormSubmit)}>
        <Stack gap={6}>
          <OverlayLoader isLoading={isLoading} />
          <TextInput id="name" labelText="Name*" placeholder="Input text" {...register('name')} />
          <TextInput
            id="attendanceRate"
            labelText="Attendance Rate*"
            placeholder="Input number"
            {...register('attendanceRate')}
          />
          <TextInput
            id="acceptableAttendanceRateDeviation"
            labelText="Acceptable Attendance Rate Deviation*"
            placeholder="Input number"
            {...register('acceptableAttendanceRateDeviation')}
          />
        </Stack>
      </Form>
    </Modal>
  );
};

export default SubGroupModal;
